import React from 'react';
import styled from 'styled-components';

import { BgColorInterface, MarginInterface, PaddingInterface } from './config/CommonInterfaces';

const WrapperContainer = styled.div<{ bg: string }>`
  min-height: 100vh;
  background-color: ${({ bg, theme: { colors } }) => colors.general[`${bg}`.toUpperCase()]};
  display: flex;
  justify-content: center;
`;

const ContentContainer = styled.div<{ lr: string, tb: string, pv: string }>`
  margin-left: ${({ lr, theme: { units } }) => units.spacing[`${lr}`.toUpperCase()]};
  margin-right: ${({ lr, theme: { units } }) => units.spacing[`${lr}`.toUpperCase()]};
  margin-top: ${({ tb, theme: { units } }) => units.spacing[`${tb}`.toUpperCase()]};
  margin-bottom: ${({ tb, theme: { units } }) => units.spacing[`${tb}`.toUpperCase()]};

  padding-top: ${({ pv, theme: { units } }) => units.spacing[`${pv}`.toUpperCase()]};
  padding-bottom: ${({ pv, theme: { units } }) => units.spacing[`${pv}`.toUpperCase()]};
  max-width: 1340px;
  flex-grow: 1;
  display: flex;
  flex-flow: column;
`;

interface ContainerProps extends BgColorInterface, MarginInterface, PaddingInterface {
  children: any,
  className: string,
}

function Container({
  children, bgColor, marginVertical,
  marginHorizontal, paddingVertical,
  className,
}: ContainerProps) {
  return (
    <WrapperContainer bg={bgColor} className={`${className}`}>
      <ContentContainer lr={marginHorizontal} tb={marginVertical} pv={paddingVertical}>
        { children }
      </ContentContainer>
    </WrapperContainer>
  );
}

export default Container;

Container.defaultProps = {
  children: null,
  bgColor: 'light',
  marginVertical: 'none',
  marginHorizontal: 'large',
  paddingVertical: 'small',
  className: '',
}
